import Footer from '@components/Footer';
import Header from '@components/Header';
import { GAME_DOWNLOAD_URLS, MACOS_UNSUPPORTED_MESSAGE, type GameId } from '@constants/index';
import '@css/sec-about.scss';
import '@css/sec-contact.scss';
import '@css/sec-main.scss';
import { useEffect, useState } from 'react';
import AboutSection from '../section/AboutSection';
import ContactSection from '../section/ContactSection';
import MainSection from '../section/MainSection';

function checkPlatform() {
    const userAgent = navigator.userAgent.toLowerCase();

    if (userAgent.includes('android')) {
        return 'aos';
    } else if (userAgent.includes('iphone') || userAgent.includes('ipad') || userAgent.includes('ipod')) {
        return 'ios';
    } else if (userAgent.includes('mac os')) {
        return 'macos';
    } else {
        return 'windows';
    }
}

const NcvMain = () => {
    const [platform, setPlatform] = useState('');
    const [country, setCountry] = useState('');

    useEffect(() => {
        setPlatform(checkPlatform());
        setCountry(document.documentElement.getAttribute('country')?.toLowerCase() ?? '');
    }, []);

    const confirmAge = (): boolean => {
        if (platform === 'macos') {
            alert(MACOS_UNSUPPORTED_MESSAGE);
            return false;
        }
        const isMobile = platform === 'ios' || platform === 'aos';
        if (!isMobile) {
            const minAge = country === 'th' ? '20' : '18';
            if (!window.confirm(`Are you ${minAge} years or over?`)) {
                return false;
            }
        }
        return true;
    };

    /**
     * Download 버튼 클릭 핸들러
     * - 플랫폼/연령 확인 후 게임별 다운로드 링크로 이동
     * - L2M: 베트남(vn)은 전용 원링크, 그 외는 SEA 공통 원링크
     * - LW: 단일 SEA 원링크
     */
    const handleDownload = (game: GameId) => {
        if (!confirmAge()) return;
        const urls = GAME_DOWNLOAD_URLS[game];
        const link = country === 'vn' && urls.vn ? urls.vn : urls.sea;
        window.open(link, '_blank');
    };

    return (
        <div className="contents-wrap">
            <Header />
            <main>
                <MainSection onDownloadClick={handleDownload} />
                <AboutSection />
                <ContactSection />
            </main>
            <Footer />
        </div>
    );
};

export default NcvMain;
